/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_geopoint.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `geo_point` value.
 * A string will only be successfully converted if it respects the
 * WKT Point format.
 *
 * @example
 * ROW wkt = "POINT(42.97109630194 14.7552534413725)"
 * | EVAL pt = TO_GEOPOINT(wkt)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_geopoint',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_point',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_point',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
